import { Link } from 'react-router-dom';
import { IconAlert } from './Icons';
import { btnPrimary, btnSoft } from './ui';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

export default function ErrorMessage({ message, onRetry }: ErrorMessageProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3 px-8 bg-white text-center">
      <span className="w-14 h-14 rounded-full bg-bad-soft text-bad inline-flex items-center justify-center">
        <IconAlert size={26} />
      </span>
      <h2 className="text-xl font-black mt-2">讀取失敗</h2>
      <p className="text-sm text-muted leading-relaxed max-w-xs">{message}</p>
      <div className="flex flex-col gap-2 w-full max-w-xs mt-4">
        {onRetry && (
          <button type="button" onClick={onRetry} className={btnPrimary}>再試一次</button>
        )}
        <Link to="/" className={btnSoft}>回首頁</Link>
      </div>
    </div>
  );
}
